<template>
<div class="chapter">
<div class="inner_page">
<h2 class="chapter" id="ack"><a id="page_5"></a>ACKNOWLEDGMENTS</h2>
<p class="indent">I would like to offer my very sincere thanks and deep appreciation to everyone at New Page Books and Career Press, particularly Michael Pye, Laurie Kelly-Pye, Kirsten Dalley, Roger Sheety, Gina Talucci, Jeff Piasky, and Adam Schwartz; and to all the staff at Warwick Associates for their fine promotion and publicity campaigns. I would also like to say a very big thank you to my literary agent, Lisa Hagan, for all her hard work and help.</p>
<p class="noindent"><a id="page_6"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ack.vue?37c4d360